import { BREAKPOINTS } from '@/ui';

export const isSmallScreen = (width) => width <= BREAKPOINTS.smd;

export const isVerySmallScreen = (width) => width <= BREAKPOINTS.sm;

export const getFontSize = (width) => (isSmallScreen(width) ? 12 : 16);

export const getStatusColumnMinWidth = (width) => (isSmallScreen(width) ? 60 : 100);

export const getNameColumnWidth = (width) => (isSmallScreen(width) ? 85 : 200);

export const getInfoColumnWidth = (width) => (isSmallScreen(width) ? 140 : 250);

export const getTableSize = (width) => (isVerySmallScreen(width) ? 'small' : 'large');

export const getFlexGap = (width) => (isVerySmallScreen(width) ? 4 : 8);

export const formatTableData = (data, isVerification, isDocumentTable) => {
  if (isVerification && data) {
    return [
      {
        key: data.id,
        name: data.questName,
        ...data
      }
    ];
  }

  return data.map((item) => ({
    key: item.id,
    name: isDocumentTable ? item.kycTypeDocument.name : item.name,
    ...item
  }));
};
